import React from 'react';
import styled from 'styled-components';

const HeroSection = styled.section`
  background: linear-gradient(rgba(12, 60, 96, 0.85), rgba(12, 60, 96, 0.85)),
              url('/images/hero-bg.png') no-repeat center center;
  background-size: cover;
  color: var(--text-light);
  padding: 5rem 0;
  text-align: center;
  position: relative;
  overflow: hidden;
`;

const HeroContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  position: relative;
  z-index: 2;
`;

const HeroTitle = styled.h1`
  font-family: 'Libre Baskerville', serif;
  font-size: 3rem;
  margin-bottom: 1.5rem;
  
  @media (max-width: 768px) {
    font-size: 2.2rem;
  }
`;

const HeroSubtitle = styled.h2`
  font-family: 'Montserrat', sans-serif;
  font-size: 1.5rem;
  font-weight: 400;
  margin-bottom: 2rem;
  color: var(--accent-color);
  
  @media (max-width: 768px) {
    font-size: 1.2rem;
  }
`;

const HeroParagraph = styled.p`
  font-family: 'Lato', sans-serif;
  font-size: 1.2rem;
  max-width: 700px;
  margin: 0 auto 2.5rem;
  
  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const Buttons = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  
  @media (max-width: 576px) {
    flex-direction: column;
    align-items: center;
  }
`;

const Button = styled.a`
  display: inline-block;
  padding: 0.8rem 1.8rem;
  background-color: ${props => props.primary ? 'var(--accent-color)' : 'transparent'};
  color: var(--text-light);
  border: ${props => props.primary ? 'none' : '2px solid var(--accent-color)'};
  border-radius: 5px;
  text-decoration: none;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 1rem;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: ${props => props.primary ? 'var(--background-light)' : 'var(--accent-color)'};
    color: ${props => props.primary ? 'var(--primary-color)' : 'var(--text-light)'};
  }
  
  @media (max-width: 576px) {
    width: 100%;
    text-align: center;
  }
`;

const ToothBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('/images/tooth.png') no-repeat center center/contain;
  opacity: 0.05;
  z-index: 1;
  transform: scale(2);
`;

const Hero = () => {
  /**
   * Opens the booking system in a new window.
   */
  const openBookingWindow = () => {
    window.open(
      "https://mychart.myoryx.ca/online-schedule/index.html?realm=finchdudley&univers=com",
      "_blank",
      "width=1000,height=700,scrollbars=yes,resizable=yes"
    );
  };

  return (
    <HeroSection id="home">
      <ToothBackground />
      <HeroContainer>
        <HeroTitle>Welcome to Finch & Dudley Dental</HeroTitle>
        <HeroSubtitle>Family and Cosmetic Dentistry in North York</HeroSubtitle>
        <HeroParagraph>
          We provide comprehensive dental care for you in a comfortable and welcoming environment. 
          Our team is dedicated to helping you achieve and maintain optimal oral health.
        </HeroParagraph>
        <Buttons>
          <Button href="tel:4162250808" primary>Call Us: 416-225-0808</Button>
          <Button href="#" onClick={(e) => { e.preventDefault(); openBookingWindow(); }}>Book Appointment</Button>
        </Buttons>
      </HeroContainer>
    </HeroSection>
  );
};

export default Hero; 